import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;

  min-height: 40vh;
  padding: 4rem 2rem;
  text-align: center;
`;

const Title = styled(Headline)`
  color: ${pickColor('grayDark')};
`;

const Info = styled(Headline)`
  max-width: 48rem;
  text-wrap: auto;
  color: ${pickColor('grayDarkSecondary')};
`;

export { Container, Info, Title };
